<template>
  <div class="modal fade" tabindex="-1" aria-labelledby="confirmModalLabel" ref="confirmRef">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content linkook-modal-box">
        <div class="linkook-modal-header">
          <h5 class="linkook-modal-title" id="confirmModalLabel">확인</h5>
          <button type="button" class="linkook-close-btn" @click="closeConfirm(false)" aria-label="닫기">×</button>
        </div>
        <div class="linkook-modal-body">
          <div v-if="modalStore.image" class="linkook-image-wrap">
            <img :src="modalStore.image" alt="" class="linkook-modal-image" />
          </div>
          <div class="linkook-modal-message" v-html="modalStore.confirmMessage"></div>
          <div v-if="modalStore.confirmOptions?.type === 'ticketPaymentConfirm'">
            <div v-if="modalStore.confirmOptions.amountText" class="ticket-amount-box">
              <div class="ticket-amount-title">입금 금액</div>
              <div class="ticket-amount-value">
                {{ modalStore.confirmOptions.amountText }}
                <span v-if="modalStore.confirmOptions.amountSubText" class="ticket-amount-sub">
                  ({{ modalStore.confirmOptions.amountSubText }})
                </span>
              </div>
            </div>

            <div class="ticket-payment-box">
              <div class="ticket-payment-title">입금 계좌 정보</div>
              <div v-if="modalStore.confirmOptions.bankName" class="ticket-payment-row">
                <span class="ticket-payment-label">은행</span>
                <span class="ticket-payment-value">{{ modalStore.confirmOptions.bankName }}</span>
              </div>
              <div v-if="modalStore.confirmOptions.accountNumber" class="ticket-payment-row">
                <span class="ticket-payment-label">계좌번호</span>
                <span class="ticket-payment-value ticket-payment-value-account">
                  <span class="ticket-payment-account-text">{{ modalStore.confirmOptions.accountNumber }}</span>
                  <button type="button" class="copy-btn-icon" @click="copyText(modalStore.confirmOptions.accountNumber)"
                    title="계좌번호 복사" aria-label="계좌번호 복사">
                    <img src="@/assets/images/file_copy_200.svg" alt="복사" />
                  </button>
                </span>
              </div>
              <div v-if="modalStore.confirmOptions.accountHolder" class="ticket-payment-row">
                <span class="ticket-payment-label">예금주</span>
                <span class="ticket-payment-value">{{ modalStore.confirmOptions.accountHolder }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="linkook-modal-footer">
          <button type="button" class="linkook-btn linkook-btn-cancel" @click="closeConfirm(false)">
            {{ modalStore.confirmOptions?.cancelLabel || '취소' }}
          </button>
          <button type="button" class="linkook-btn linkook-btn-primary" @click="closeConfirm(true)">
            {{ modalStore.confirmOptions?.confirmLabel || '확인' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import { useModalStore } from "@/store/modal";

export default {
  data() {
    return {
      modalInstance: null,
      modalStore: useModalStore(),
      result: false,
    };
  },
  mounted() {
    this.modalInstance = new Modal(this.$refs.confirmRef, {
      backdrop: "static",
    });
  },
  watch: {
    "modalStore.showConfirm"(newVal) {
      if (this.modalInstance) {
        if (newVal) {
          this.result = false;
          this.modalInstance.show();
        }
      }
    },
  },
  methods: {
    closeConfirm(result) {
      this.result = result;
      document.activeElement?.blur();
      this.modalInstance.hide();
      this.$closeConfirm(result);
    },
    async copyText(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.modalStore.showAlertModal("계좌번호가 복사되었습니다.");
      } catch (e) {
        console.error("복사 오류:", e);
        this.modalStore.showAlertModal("복사에 실패했습니다.");
      }
    },
    closeModal() {
      document.activeElement?.blur();
      this.modalInstance.hide();
    },
  },
};
</script>

<style scoped>
.linkook-modal-box {
  background: white !important;
  border: none !important;
  border-radius: 8px !important;
  width: 90%;
  max-width: 400px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
}

.linkook-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e9ecef;
  font-style: normal;
}

.linkook-modal-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  font-family: "NanumSquareRoundB", sans-serif;
  font-style: normal;
}

.linkook-close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.linkook-close-btn:hover {
  color: #333;
}

.linkook-modal-body {
  padding: 20px;
}

.linkook-image-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.linkook-modal-image {
  max-width: 120px;
  max-height: 120px;
  object-fit: contain;
  border-radius: 8px;
}

.linkook-modal-message {
  white-space: pre-line;
  font-size: 14px;
  color: #333;
  line-height: 1.5;
  margin: 0;
}

.ticket-payment-box {
  margin-top: 14px;
  border: 1px solid #e9ecef;
  border-radius: 10px;
  padding: 12px;
  background: #fafafa;
}

.ticket-amount-box {
  margin-top: 14px;
  border: 1px solid rgba(102, 189, 255, 0.35);
  border-radius: 12px;
  padding: 12px;
  background: rgba(102, 189, 255, 0.08);
}

.ticket-amount-title {
  font-family: "NanumSquareRoundB", sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.ticket-amount-value {
  font-family: "NanumSquareRoundB", sans-serif;
  font-size: 16px;
  color: #1e40af;
  line-height: 1.35;
}

.ticket-amount-sub {
  margin-left: 6px;
  font-family: "NanumSquareRoundR", sans-serif;
  font-size: 11px;
  color: #475569;
}

.ticket-payment-title {
  font-family: "NanumSquareRoundB", sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.ticket-payment-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid #f1f3f5;
}

.ticket-payment-row:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.ticket-payment-label {
  flex: 0 0 72px;
  font-family: "NanumSquareRoundB", sans-serif;
  font-size: 12px;
  color: #495057;
  margin: auto;
}

.ticket-payment-value {
  flex: 1;
  min-width: 0;
  font-family: "NanumSquareRoundR", sans-serif;
  font-size: 12px;
  color: #212529;
  overflow-wrap: anywhere;
}

.ticket-payment-value-account {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.ticket-payment-account-text {
  overflow-wrap: anywhere;
}

.copy-btn-icon {
  background: none;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s ease;
  padding: 6px;
}

.copy-btn-icon:hover {
  background: #e9ecef;
}

.copy-btn-icon:active {
  background: #dee2e6;
}

.copy-btn-icon img {
  width: 16px;
  height: 16px;
  opacity: 0.6;
  transition: opacity 0.2s ease;
}

.copy-btn-icon:hover img {
  opacity: 0.9;
}

.linkook-modal-footer {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding: 20px;
  border-top: 1px solid #e9ecef;
}

.linkook-btn {
  padding: 10px 20px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: "NanumSquareRoundR", sans-serif;
  border: none;
}

.linkook-btn-cancel {
  background: #6c757d;
  color: white;
}

.linkook-btn-cancel:hover {
  background: #5a6268;
}

.linkook-btn-primary {
  background: #0d6efd;
  color: white;
}

.linkook-btn-primary:hover {
  background: #0b5ed7;
}
</style>
